import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { E_FLOW_HEX, L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const COOLER_CONFIG = {
    type: ERFElement.Cooler,
    icon: 'Cooler_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Left,
                    style: { top: 37, left: 12, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow',
                    type: 'source',
                    name: 'Выходной материальный поток',
                    position: Position.Right,
                    style: { top: 37, right: 11, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_energy_flow',
                    type: 'source',
                    name: 'Выходной энергетический поток',
                    position: Position.Top,
                    style: { top: 8, left: 66, background: E_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 50, left: 16, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 50, right: 16, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFCoolerNode.config.js.map